var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c("div", { attrs: { id: "containerHeader" } }, [
      _c("div", { staticClass: "flex-aligned" }, [
        _c(
          "div",
          { attrs: { id: "logoContainer" }, on: { click: _vm.onLogoNavigate } },
          [_c("img", { attrs: { src: _vm.imageLogoSrc } })]
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "LineSeparator" } }),
        _vm._v(" "),
        _c("div", [
          _c("p", { attrs: { id: "descricaoLogo" } }, [
            _vm._v(_vm._s(_vm.descricaoLogo))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [_vm._t("RightButtons")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f825300", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f825300","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/layout/Headers/HeaderCentral/HeaderCentral.vue
// module id = null
// module chunks = 